import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Component, HostListener, OnDestroy } from '@angular/core';
import { OpeningService } from 'src/app/core/services/opening.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { AperturaPayload, ArticleData, Articles, BlockRequest, StatusResponse, BlockResponse } from 'src/app/models/opening';
import Swal from 'sweetalert2';
import { Subscription, timer } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { Categories } from '../../../models/first-note-scroll';

interface SectionConfig {
  openingStatus: boolean; // normal / emergencia
  mode: 'manual' | 'automatico';
  isUnlocked: boolean;
}


@Component({
  selector: 'app-home-opening',
  templateUrl: './home-opening.component.html',
  styleUrls: ['./home-opening.component.css']
})
export class HomeOpeningComponent  implements OnDestroy {

  openigStatus: boolean = false;
  isUnlocked: boolean = false;
  selectedSection: string = '';
  //sections: string[] = [];
  sections: { key: string; name: string }[] = [];

  tipoNota: 'normal' | 'grilla' | 'emergencia' = 'normal';
  mode: 'manual' | 'automatico' = 'manual';
  sectionConfigMap: Record<string, SectionConfig> = {};
  isUrlDisabled: boolean = false;
  urlInput: string = '';
  errorUrls: string[] = [];
  loadingA: boolean = false;

  showOpening: boolean = false;
  showGrid: boolean = false;
  showEmergency: boolean = false;

  notas: (ArticleData & { tipo: 'normal' | 'grilla' | 'emergencia' })[] = [];
  notasNormalList: any[] = [];
  notasGrillaList: any[] = [];
  notasEmergenciaList: any[] = [];
  connectedDropLists: string[] = ['listaApertura', 'listaGrilla', 'listaEmergencia'];
  
  cantidadNotasEmergencia: number = 1;
  backupGrillaOriginal: ArticleData[] = [];
  backupNotasNormalOriginal: ArticleData[] = [];

  private myEmail: string;
  public status:string = '';
  public lockingUser: string = '';

  private pollingSubscription: Subscription;
  public isButtonEnabled: boolean = true; // Inicia deshabilitado por defecto
  private stopChecking: boolean = false;  


  private backups: {
    [section: string]: {
      normal: ArticleData[];
      grilla: ArticleData[];
    }
  } = {};
  

  constructor(private openingService: OpeningService, private AuthService: AuthService) {}
  
  ngOnInit(): void {

    this.myEmail = this.AuthService.getUserLogged();

    this.loadOpeningFromApi();
    this.loadSections();
    //Siempre ingresa primero al home
    this.checkSectionStatus("home");

  } 

  private applySectionConfig(section: string): void {
    const config = this.sectionConfigMap[section];
    if (!config) return;
  
    this.openigStatus = config.openingStatus;
    this.mode = config.mode;
    this.isUnlocked = config.isUnlocked;
  
    this.updateUrlInputState();
  }
  
  onChangeOpeningType(value: boolean) {
    this.sectionConfigMap[this.selectedSection].openingStatus = value;
    console.log('[onChangeOpeningType] valor nuevo:', value); 
  
    this.openigStatus = value;
    this.tipoNota = value ? 'emergencia' : 'normal';
  
    if (value) {
      // Cambio a emergencia: mover primera nota de normal
      const todasNormales = [...this.notasNormalList];
  
      const nuevaEmergencia = todasNormales.slice(0, 1).map(n => ({
        ...n,
        tipo: 'emergencia'
      }));
  
      const nuevasGrillaDesdeNormal = todasNormales.slice(1).map(n => ({
        ...n,
        tipo: 'grilla'
      }));
  
      // No modificar los backups aquí
  
      // Limpia normal y pasa a emergencia
      this.notasNormalList = [];
      this.notasEmergenciaList = nuevaEmergencia;
  
      // Fusiona con grilla actual sin duplicados
      const nuevasGrillaFinal = [...nuevasGrillaDesdeNormal, ...this.notasGrillaList]
        .filter((n, i, self) => self.findIndex(x => x.id === n.id) === i)
        .slice(0, 16)
        .map(n => ({ ...n, tipo: 'grilla' }));
  
      this.notasGrillaList = nuevasGrillaFinal;
  
    } else {
      // Volver a normal: restaurar desde backups
      const originalesNormal = [...this.backupNotasNormalOriginal];
      const originalesGrilla = [...this.backupGrillaOriginal];
  
      this.notasNormalList = originalesNormal.slice(0, 7).map(n => ({ ...n, tipo: 'normal' }));
  
      const idsNormal = new Set(this.notasNormalList.map(n => n.id));
  
      this.notasGrillaList = originalesGrilla
        .filter(n => !idsNormal.has(n.id))
        .map(n => ({ ...n, tipo: 'grilla' }))
        .slice(0, 16);
  
      this.notasEmergenciaList = [];
    }
  
    // Reconstruye lista general y sincroniza
    this.notas = [
      ...this.notasNormalList,
      ...this.notasEmergenciaList,
      ...this.notasGrillaList
    ];
  
    this.syncLists();
    this.setShowFlags();

    if (value) {
      if (this.mode === 'automatico') {
        this.mode = 'manual';
        this.sectionConfigMap[this.selectedSection].mode = 'manual';
        this.showAutomaticNotAllowedAlert();
      }
    }    
  
    this.updateUrlInputState();
  
    console.log('Cambio apertura ->', {
      normal: this.notasNormalList.length,
      emergencia: this.notasEmergenciaList.length,
      grilla: this.notasGrillaList.length
    });
  }

  updateUrlInputState() {
    // Solo se bloquea en apertura normal + automático
    this.isUrlDisabled = !this.openigStatus && this.mode === 'automatico';
  }
x  
  

  checkSectionStatus(section: string): void {
    
    //const myEmail = this.AuthService.getUserLogged();
    this.selectedSection = section;

    // Si ya existe una suscripción de polling activa, la cancelamos antes de iniciar una nueva.
    if (this.pollingSubscription && !this.pollingSubscription.closed) {
      this.pollingSubscription.unsubscribe();
    }

    // Usamos timer(0, 3000) para iniciar la verificación inmediatamente y luego repetirla cada 3 segundos.
    this.pollingSubscription = timer(0, 5000).pipe(
      // switchMap cancela la petición anterior si una nueva se emite, ideal para polling.
      switchMap(() => this.openingService.checkSectionStatus(section))
    ).subscribe({
      next: (respuesta: StatusResponse) => {

        if(this.stopChecking){
           if (this.pollingSubscription) {
              this.pollingSubscription.unsubscribe();
            }
        }
        
        if (respuesta.data === this.myEmail) {
          // CONDICIÓN CUMPLIDA: El email coincide.
          
          
          this.status = 'bloqueadoPorMi';
          this.isButtonEnabled = true;
          this.isUnlocked = false;
          
          // Detenemos el ciclo de polling porque ya tenemos el control.
          /*if (this.pollingSubscription) {
            this.pollingSubscription.unsubscribe();
          }*/
          
          // Aquí puedes realizar acciones adicionales (ej: habilitar la edición).
        }else if(respuesta.data === "" ){

           this.status = 'libre';

          if(!this.stopChecking){
            this.lockSection(this.myEmail);
          }

          // Detenemos el polling mientras el usuario decide qué hacer.
          if (this.pollingSubscription) {
            this.pollingSubscription.unsubscribe();
          }
        

        } else {
          // CONDICIÓN NO CUMPLIDA: La sección está bloqueada por otro usuario.
          
          this.status = 'bloqueadoPorOtro';
          this.isUnlocked = false;
          this.lockingUser = respuesta.data;
          
          // Detenemos el polling mientras el usuario decide qué hacer.
          if (this.pollingSubscription) {
            this.pollingSubscription.unsubscribe();
          }

          // Mostramos el diálogo de SweetAlert
          Swal.fire({
            icon: 'warning',
            title: 'CONTENIDO BLOQUEADO',
            html: `Esta sección se encuentra en uso por: <strong>${respuesta.data}</strong>.<br><br>
                   Para permitir que su usuario realice cambios, de clic al botón <strong>Tomar sección</strong>, de lo contrario, cancele.`,
            showCancelButton: true,
            confirmButtonText: 'Tomar sección',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#3C00A3',
            cancelButtonColor: '#D6E0FF',
            customClass: {
              cancelButton: 'swal-cancel-text-color'
            } 
          }).then(result => {
            if (result.isConfirmed) {
              
              this.lockSection(this.myEmail);

            } else {
              // El usuario canceló. Según tu requisito, volvemos a verificar cada 3 segundos.
              console.log("El usuario canceló. Reiniciando la verificación periódica.");

              this.isButtonEnabled = false;
                
              if (this.pollingSubscription) {
                this.pollingSubscription.unsubscribe();
              }

              // Simplemente reiniciamos el ciclo de polling.
              //this.checkSectionStatus(this.selectedSection); 
            }
          });
        }
      },
      error: (err) => {
        // En caso de error de API, el ciclo de timer se detiene por defecto.
        // Aquí podrías decidir si quieres reintentarlo. Por simplicidad, solo lo logueamos.
        console.error("Error en la llamada al servicio. Se detuvo la verificación.", err);
      }
    });
  }

  onChangeMode(event: Event, input: HTMLInputElement) {
    const isChecked = input.checked;
  
    // CASO BLOQUEADO:
    if (this.openigStatus && isChecked) {
      // Mostrar alerta
      this.showAutomaticNotAllowedAlert();
  
      // 🔥 FORZAR VISUALMENTE EL SWITCH A MANUAL
      input.checked = false;
      this.mode = 'manual';
  
      return;
    }
  
    // CASO NORMAL
    // CASO NORMAL
    this.mode = isChecked ? 'automatico' : 'manual';

    // 🔥 GUARDAR EN CONFIG DE LA SECCIÓN
    this.sectionConfigMap[this.selectedSection].mode = this.mode;

    this.updateUrlInputState();

  }
  
  

  private showAutomaticNotAllowedAlert() {
    Swal.fire({
      icon: 'warning',
      title: 'Acción no permitida',
      text: 'La acción en automático no está permitido en la apertura de emergencia',
      confirmButtonColor: '#3C00A3'
    });
  }
  


  lockSection(email: string, showMessage:boolean = false):void{
    const payload: BlockRequest = {
        section: this.selectedSection,
        email: email
    };

    this.openingService.blockSection(payload).subscribe((blockResponse: BlockResponse) => {
      this.checkSectionStatus(this.selectedSection); 
      
      if(showMessage){
          Swal.fire({
            icon: 'success',
            title: 'CONTENIDO LIBERADO',
            text: 'Sección liberada con éxito. Para bloquear nuevamente la página de clic acá, recuerde que otro usuario pudo haber bloqueado esta sección previamente.',
            confirmButtonColor: '#3C00A3'
          });
      }

    });

  }

  freeSection(showMessage:boolean=false, stopChecking:boolean):void{
    this.stopChecking = stopChecking;
    this.lockSection("", showMessage);
  }
  

  loadSections(): void {
    this.openingService.getMenuSections()
      .then(sections => {
        // Agregamos "home" al inicio
        this.sections = [
          { key: 'home', name: 'Home' },
          ...sections.sort((a, b) => a.name.localeCompare(b.name)) // ordena alfabéticamente

        ];
  
        // Si aún no hay sección seleccionada, dejamos "home"
        if (!this.selectedSection) {
          this.selectedSection = 'home';
        }
      })
      .catch(error => {
        console.error('Error al cargar secciones:', error);
      });
  }
  
  

  
  addArticle() {
    const urlInput = this.urlInput.trim();
    if (!urlInput) return;

    if (this.isUrlDisabled) {
      return;
    }
  
    const code = this.openingService.getCodeFromPublicUrl(urlInput);
    if (!code) {
      this.errorUrls.push(urlInput);
      this.urlInput = '';
      return;
    }
  
    this.loadingA = true;
  
    this.openingService.getArticleFromCode(code)
      .then((data: any) => {
  
        const notaDuplicada = this.notas.some(n => n.id === data.id);
        if (notaDuplicada) {
          Swal.fire({
            icon: 'warning',
            title: 'Nota duplicada',
            text: 'Esta nota ya fue agregada.',
            confirmButtonColor: '#3C00A3'
          });
          this.urlInput = '';
          this.loadingA = false;
          return;
        }

        const mainTitle = data.titles?.main?.trim() || '';
        const pulzoTitle = data.titles?.pulzo?.trim() || '';
  
        let nuevaNota: ArticleData & { tipo: 'normal' | 'grilla' | 'emergencia'; mostrarTituloHome?: boolean } = {
          id: data.id,
          title: data.title || data.titles?.main || 'Sin título',
          titleAltern: data.titleAltern || data.titles?.pulzo,
          lead: data.lead || data.phrases?.main,
          url: data.url || data.urls?.main,
          status: data.status || '',
          type: data.type || '',
          image: {
            src: data.images?.types?.square?.small || '',
            alt: data.images?.meta?.alt || ''
          },
          images: data.images,
          videos: data.videos,
          externalUrl: data.externalUrl,
          section: {
            slug: data.section?.slug || data.categories?.main?.slug || '',
            name: data.section?.name || data.categories?.main?.name || 'Sin sección'
          },
          articlesSeo: data.articlesSeo || [],
          author: {
              image: data.author?.owner?.image || '',
              name: data.author?.creator?.name || data.author?.name || 'Sin autor',
              nickname: data.author?.creator?.nickname || data.author?.nickname || '',
              url: ''
          },
          trinoTW: data.trinoTW,
          audio: data.audio,
          ext: data.ext,
          summary: data.summary,
          post_author: data.post_author,
          opening: data.opening || false,
          created: data.created,
          icon: data.icon,
          tipo: this.tipoNota,
          mostrarTituloHome: mainTitle !== pulzoTitle,
          hermes:{
            logo: data.hermes?.company.logo
          }
        };

        switch(this.getArticleSignType(data)){
          case 'redaccion':
            nuevaNota.author.image = data.author.owner.image;
            nuevaNota.author.url = 'https://www.pulzo.com/autor/'+this.getSlug(data.author.creator.name);
          break;
          case 'aliados':
            nuevaNota.author.image = data.hermes.company.logo;
            nuevaNota.author.nickname = data.author.creator.name;
            nuevaNota.author.url = 'https://www.pulzo.com/noticias/'+this.getSlug(data.hermes.company.name);
          break;
          //Articulo normal
          default:
              nuevaNota.author.image = 'https://d2yoo3qu6vrk5d.cloudfront.net/pulzo-dev/RonaldImages/favicon-64.png';
              nuevaNota.author.url = 'https://www.pulzo.com';
              if(data.categories.parent.slug != ""){
                nuevaNota.author.url += '/' + data.categories.parent.slug;
              }
              nuevaNota.author.url += '/' + data.categories.main.slug;
          break;
        }
        
  
        // Agrega nota según el tipo
        if (this.tipoNota === 'normal') {
          if (this.notasNormalList.length >= 7) {
            const ultimaNormal = this.notasNormalList.pop();
            if (ultimaNormal) {
              ultimaNormal.tipo = 'grilla';
              if (this.notasGrillaList.length >= 16) {
                this.notasGrillaList.pop(); // Quita última grilla si está llena
              }
              this.notasGrillaList.unshift(ultimaNormal);
            }
          }
          //nuevaNota.tipo = 'normal';
          this.notasNormalList.unshift(nuevaNota);
        }
  
        else if (this.tipoNota === 'emergencia') {
          if (this.notasEmergenciaList.length >= 5) {
            const ultimaEmergencia = this.notasEmergenciaList.pop();
            if (ultimaEmergencia) {
              ultimaEmergencia.tipo = 'grilla';
              if (this.notasGrillaList.length >= 16) {
                this.notasGrillaList.pop(); // Quita última grilla si está llena
              }
              this.notasGrillaList.unshift(ultimaEmergencia);
            }
          }
          //nuevaNota.tipo = 'emergencia';
          this.notasEmergenciaList.unshift(nuevaNota);
        }
  
        else if (this.tipoNota === 'grilla') {
          if (this.notasGrillaList.length >= 16) {
            this.notasGrillaList.pop();
          }
          //nuevaNota.tipo = 'grilla';
          this.notasGrillaList.unshift(nuevaNota);
        }


  
        // Combina todas para mostrar
        this.notas = [
          ...this.notasNormalList,
          ...this.notasEmergenciaList,
          ...this.notasGrillaList
        ];
  
        this.syncLists();
        this.setShowFlags();
  
        this.urlInput = '';
        this.loadingA = false;
      })
      .catch((error) => {
        console.error('Error con fetch:', error);
        this.errorUrls.push(urlInput);
        this.urlInput = '';
        this.loadingA = false;
      });

      
  }

  getArticleSignType(article){

    let signType = 'pulzo';

    if(article.type == 'aliados'){
      signType = 'aliados';
    }else if(article.autores != '0'){
      signType = 'redaccion';
    }

    return signType;

  }

  getSlug(texto){
    return texto.toLowerCase().replace(/\s+/g, '-');
  }
  
  getConsecutiveIndex(i: number, type: 'normal' | 'grilla' | 'emergencia'): number {
    if (this.openigStatus) {
      // Emergencia activa → grilla + emergencia
      if (type === 'emergencia') {
        return i + 1;
      } else if (type === 'grilla') {
        return this.notasEmergenciaList.length + i + 1;
      }
    } else {
      // Apertura normal → grilla + apertura
      if (type === 'normal') {
        return i + 1;
      } else if (type === 'grilla') {
        return this.notasNormalList.length + i + 1;
      }
    }
    return i + 1;
  }

  setShowFlags() {
    this.showOpening = this.notas.some(n => n.tipo === 'normal');
    this.showEmergency = this.notas.some(n => n.tipo === 'emergencia');
    this.showGrid = this.notas.some(n => n.tipo === 'grilla');
  }

  syncLists() {
    this.notasNormalList = this.notas.filter(n => n.tipo === 'normal');
    this.notasGrillaList = this.notas.filter(n => n.tipo === 'grilla');
    this.notasEmergenciaList = this.notas.filter(n => n.tipo === 'emergencia');
  }
    
  drop(event: CdkDragDrop<any[]>) {

    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      const destinoId = event.container.id;
      const origenId = event.previousContainer.id;
      
      const item = event.previousContainer.data[event.previousIndex];

      const notaDuplicada = event.container.data.some(nota => nota.id === item.id);

      if (notaDuplicada) {
        Swal.fire({
          icon: 'warning',
          title: 'Nota ya existe en esta sección',
          text: 'Esta nota ya está en la sección destino.',
          confirmButtonColor: '#3C00A3'
        });
        return;
      }

      if (destinoId === 'listaApertura') item.tipo = 'normal';
      else if (destinoId === 'listaEmergencia') item.tipo = 'emergencia';
      else if (destinoId === 'listaGrilla') item.tipo = 'grilla';

      transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
    }

    this.notas = [
      ...this.notasNormalList,
      ...this.notasEmergenciaList,
      ...this.notasGrillaList
    ];
    this.syncLists();
  }
  
  sendArticles(): void {
    const openingType = this.openigStatus ? 'emergencia' : 'normal';

    if (!this.openigStatus && this.notasNormalList.length < 7) {
      Swal.fire({
        icon: 'warning',
        title: 'Notas insuficientes en la apertura normal',
        text: 'Debes tener al menos 7 notas en la apertura normal para poder guardar.',
        confirmButtonColor: '#3C00A3'
      });
      return;
    }

    if (!this.openigStatus && this.notasNormalList.length > 7) {
      Swal.fire({
        icon: 'error',
        title: 'Notas excedidas en apertura normal',
        text: 'Solo se permiten 7 notas en apertura normal.',
        confirmButtonColor: '#3C00A3'
      });
      return;
    }
  
    // Validación de apertura emergencia
    if (this.openigStatus && this.notasEmergenciaList.length > 5) {
      Swal.fire({
        icon: 'error',
        title: 'Notas excedidas en apertura emergencia',
        text: 'Solo se permiten hasta 5 notas en apertura emergencia.',
        confirmButtonColor: '#3C00A3'
      });
      return;
    }

    if (this.notasGrillaList.length < 16) {
      Swal.fire({
        icon: 'warning',
        title: 'Notas insuficientes en grilla',
        text: 'Debes tener al menos 16 notas en la sección de grilla.',
        confirmButtonColor: '#3C00A3'
      });
      return;
    }

    if (this.notasGrillaList.length > 16) {
      Swal.fire({
        icon: 'error',
        title: 'Notas excedidas en grilla',
        text: 'Solo se permiten 16 notas en grilla.',
        confirmButtonColor: '#3C00A3'
      });
      return;
    }
  
    const articles: Articles[] = [...this.notasNormalList, ...this.notasEmergenciaList].map(n => ({ data: n }));
    const grid: Articles[] = this.notasGrillaList.map((nota) => ({ data: nota }));  

    this.sectionConfigMap[this.selectedSection] = {
      openingStatus: this.openigStatus,
      mode: this.mode,
      isUnlocked: this.isUnlocked
    };
  
    const payload: AperturaPayload = {
      seccion: this.selectedSection,
      apertura: {
        openingType,
        automaticOpening: this.mode === 'automatico',
        articles
      },
      grid
    };
    
  
    console.log('save', payload);

    this.openingService.saveOpening(payload).subscribe({
      next: () => {
        Swal.fire({
          icon: 'success',
          title: '¡Guardado!',
          text: 'La apertura se guardó correctamente.',
          confirmButtonColor: '#3C00A3'
        });

      },
      error: (err) => {
        console.error('Error al guardar:', err);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo guardar la apertura.',
          confirmButtonColor: '#3C00A3'
        });
      }
    });
  }
  
  

  saveArticles(){
    Swal.fire({
      title: "¿Está seguro de guardar?",
      text: "",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3C00A3",
      cancelButtonColor: "#D6E0FF",
      confirmButtonText: "Guardar",
      cancelButtonText: "Cancelar",
      customClass: {
        cancelButton: 'swal-cancel-text-color'
      }  

    }).then((result) => {
      if (result.isConfirmed) {
          this.sendArticles(); 
      }
    });
  }

  deleteArticle(index: number, tipo: 'normal' | 'grilla' | 'emergencia') {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Vas a eliminar esta nota y cambiarla por una nueva.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3C00A3',
      cancelButtonColor: '#D6E0FF',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
      customClass: {
        cancelButton: 'swal-cancel-text-color'
      } 
    }).then((result) => {
      if (result.isConfirmed) {
        const lista = this[`notas${tipo.charAt(0).toUpperCase() + tipo.slice(1)}List`];
        lista.splice(index, 1);
        this.notas = [
          ...this.notasNormalList,
          ...this.notasEmergenciaList,
          ...this.notasGrillaList
        ];
        this.syncLists();
      }
    });
  }

  onSectionChange() {
    Swal.fire({
      title: "¿Está seguro de salir?",
      text: "",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3C00A3",
      cancelButtonColor: "#D6E0FF",
      confirmButtonText: "Si",
      cancelButtonText: "Cancelar",
      customClass: {
        cancelButton: 'swal-cancel-text-color'
      } 
    }).then((result) => {
      if (result.isConfirmed) {
        //Liberamos la seccion
        this.freeSection(false, false);
        //Buscamos la información de la grilla
        this.loadOpeningFromApi(this.selectedSection);
        this.checkSectionStatus(this.selectedSection);

        // 🔥 RESTAURA ESTADO VISUAL
        this.applySectionConfig(this.selectedSection);

      }
    });
    
  }
  
//Mostrar en la vista
  loadOpeningFromApi(section: string = 'home') {
    this.openingService.getOpeningFromApi(section)
      .then((payload) => {

        console.log(payload);

        const seccion = payload.seccion || section;
        this.selectedSection = seccion;

        if (!this.sectionConfigMap[seccion]) {
          this.sectionConfigMap[seccion] = {
            openingStatus: payload.apertura.openingType === 'emergencia',
            mode: payload.apertura.automaticOpening ? 'automatico' : 'manual',
            isUnlocked: false
          };
        }

        // 🔥 APLICAMOS CONFIG VISUAL
        this.applySectionConfig(seccion);

        const tipo = this.openigStatus ? 'emergencia' : 'normal';
        this.tipoNota = tipo;

  
        const allNotas = [...payload.apertura.articles, ...payload.grid];

        // Evita duplicados (con control de mayúsculas/minúsculas)
        const lowerSections = this.sections.map(s => s.key.toLowerCase());
        if (!lowerSections.includes(seccion.toLowerCase())) {
          this.sections.unshift({ key: seccion, name: seccion });

        }

        const notasFiltradas = allNotas.filter((nota, index, self) => {
          return index === self.findIndex(n => n.data.id === nota.data.id);
        });
  
        this.notas = notasFiltradas.map((item) => {
          const imageSrc = item.data.images?.types?.square?.small || '';
          const imageAlt = item.data.images?.meta?.alt || '';

          const tituloMain = item.data.title?.trim() || '';
          const tituloPulzo = item.data.titleAltern?.trim() || '';

        
          return {
            ...item.data,
            image: {
              src: imageSrc,
              alt: imageAlt
            },
            tipo: this.getTipoFromPayload(item, payload),
            mostrarTituloHome: tituloMain !== tituloPulzo
          };
         
        });
        
        // Reiniciar backups cada vez que se cambia de sección
        this.backupNotasNormalOriginal = [];
        this.backupGrillaOriginal = [];
 
       // Restauramos backups SOLO si aún no existen
       if (!this.backupNotasNormalOriginal.length && tipo === 'normal') {
        this.backupNotasNormalOriginal = payload.apertura.articles
          .slice(0, 7)
          .map(item => ({
            ...item.data,
            image: {
              src: item.data.images?.types?.square?.small || '',
              alt: item.data.images?.meta?.alt || ''
            },
            tipo: 'normal',
            mostrarTituloHome: item.data.title?.trim() !== item.data.titleAltern?.trim()
          }));
      }

      if (!this.backupGrillaOriginal.length && tipo === 'normal') {
        this.backupGrillaOriginal = payload.grid
          .slice(0, 16)
          .map(item => ({
            ...item.data,
            image: {
              src: item.data.images?.types?.square?.small || '',
              alt: item.data.images?.meta?.alt || ''
            },
            tipo: 'grilla',
            mostrarTituloHome: item.data.title?.trim() !== item.data.titleAltern?.trim()
          }));
      }

      // Si estamos en emergencia y no hay backup, intenta reconstruir normal/grilla
      if (tipo === 'emergencia' && !this.backupNotasNormalOriginal.length) {
        const emergenciaNotas = payload.apertura.articles.map(item => item.data.id);
        const posiblesNormales = payload.grid
          .filter(item => !emergenciaNotas.includes(item.data.id))
          .slice(0, 7)
          .map(item => ({
            ...item.data,
            image: {
              src: item.data.images?.types?.square?.small || '',
              alt: item.data.images?.meta?.alt || ''
            },
            tipo: 'normal',
            mostrarTituloHome: item.data.title?.trim() !== item.data.titleAltern?.trim()
          }));

        this.backupNotasNormalOriginal = posiblesNormales;
      }

      if (tipo === 'emergencia' && !this.backupGrillaOriginal.length) {
        this.backupGrillaOriginal = payload.grid
          .slice(0, 16)
          .map(item => ({
            ...item.data,
            image: {
              src: item.data.images?.types?.square?.small || '',
              alt: item.data.images?.meta?.alt || ''
            },
            tipo: 'grilla',
            mostrarTituloHome: item.data.title?.trim() !== item.data.titleAltern?.trim()
          }));
      }
      
      
      // Set cantidad emergencia por default
      if (this.openigStatus) {
        this.cantidadNotasEmergencia = Math.min(this.notasEmergenciaList.length, 5) || 1;
      }

      this.syncLists();
      this.setShowFlags();

    })
      .catch((error) => {
        console.error('Error al cargar apertura:', error);
      });
  }


 
  
  
  getTipoFromPayload(item: Articles, payload: AperturaPayload): 'normal' | 'grilla' | 'emergencia' {
    const isGrid = payload.grid.includes(item);
    if (isGrid) return 'grilla';
  
    return payload.apertura.openingType === 'emergencia' ? 'emergencia' : 'normal';
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any): void {
    // Esta línea es necesaria para algunos navegadores
    $event.returnValue = true;
  }

  ngOnDestroy(): void {
    // Es CRUCIAL desuscribirse cuando el componente se destruye para evitar memory leaks.
    if (this.pollingSubscription && !this.pollingSubscription.closed) {
      this.pollingSubscription.unsubscribe();
    }
  }

}